import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]

import {onMounted, ref} from "vue";
	import {FetchData} from "../utils/FetchData";
	import LoadingCircleAnimation from '../components/LoadingCircleAnimation.vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SelectSeason',
  emits: [
		'seasonClicked'
	],
  setup(__props, { emit: __emit }) {

	const emit = __emit;

	const seasons = ref([]);
	const loading = ref(true);

	async function retrieveSeasons() {
		const data = await FetchData("seasons");
		if(!data.isError)
			seasons.value = data.data;

		loading.value = false;
	}

	onMounted(() => {
		retrieveSeasons();
	});

	function selectSeason(season: object) {
		emit('seasonClicked', season);
	}


return (_ctx: any,_cache: any) => {
  return (!loading.value)
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(seasons.value, (season) => {
        return (_openBlock(), _createElementBlock("button", {
          key: season.id,
          class: "content-box",
          onClick: ($event: any) => (selectSeason(season))
        }, _toDisplayString(season.name), 9, _hoisted_1))
      }), 128))
    : (loading.value)
      ? (_openBlock(), _createBlock(LoadingCircleAnimation, {
          key: 1,
          width: "100"
        }))
      : _createCommentVNode("", true)
}
}

})